import { Card, InputAdornment, Popover, Tooltip } from "@mui/material";
import TextField from "@mui/material/TextField";
import moment from 'moment';
import React, { useEffect, useState } from "react";
import Calendar from "react-calendar";
import { UtilityService } from "../../../services/UtilityService";
import "../../theme/calendar.scss";
import ButtonComponent from "../button/button.component";
import ArrowTimePickerTimeComponent from "./arrow-time.component-new";
import { DateTimePickerIcon, InformationDarkScheduleIcon, ResetIcon } from "../../../icon";

interface Props {
	handleChange: (dateTime: number,ID?:string) => void;
	DateTime: number;
	IsMobileDevice?: boolean;
	DeviceWidth?: number;
	HideTime?: boolean;
	isMessage?: boolean;
	TextLabel?: string;
	renderDateTime?: () => JSX.Element;
	FormatText?: string;
	FormatTextLabel?: string;
	event?: any;
	anchorEl?: any;
	CloseBottomDrawer?: () => void;
	CloseCalender?: () => void;
	maxDateTime?: number;
	TextFiledMediumSize?: boolean;
	MaxDate?: boolean;
	ShowRestIcon?: boolean;
	ID?:string;
}

export default function DateAndTimePicker(props: Props) {
	const [value, setValue] = React.useState(UtilityService.convertToPreferredTimeZone(props.DateTime) > UtilityService.getPreferredTimeZoneTimeNow() ? UtilityService.convertToPreferredTimeZone(props.DateTime) : UtilityService.getPreferredTimeZoneTimeNow());
	const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
	const [openCalender, setOpenCalender] = React.useState<boolean>(false);
	const [selectedDate, setSelectedDate] = useState<number>(null)
	const minuteStep = 10;

	useEffect(() => {
		if (props.event !== undefined) {
			setAnchorEl(props.event.currentTarget);
			setOpenCalender(true);
		}
	}, [])

	const handleClick = (event: any) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		if (props.event !== undefined) {
			setOpenCalender(false);
			props.CloseCalender();
		}
		setAnchorEl(null);
	};

	const handlePopoverClose = () => {
		if (props.event !== undefined) {
			setOpenCalender(false);
			props.CloseCalender();
		}
		setAnchorEl(null);
	};

	const onChange = (date: any) => {
		setSelectedDate(date.getTime())
		let fDate = UtilityService.convertToDateFormat(date);
		let fTime = UtilityService.convertToTimeFormat(value);
		// for maintance will be removed in feature		
		// let fDate = moment(date,
		// ).format("MM-DD-YYYY");
		// let fTime = moment(value, ["HH:mm"]
		// ).format("HH:mm");
		// let x = moment(`${fDate} ${fTime}`, ["MM-DD-YYYY HH:mm"]
		// ).format(`MM-DD-YYYY HH:mm`);
		let x = UtilityService.convertToDateTimeFormat(`${fDate} ${fTime}`)
		setValue(new Date(x));
		if (props.HideTime) {
			props.handleChange(UtilityService.roundTimeToMinutes(new Date(x).getTime(), minuteStep),props.ID);
			handleClose();
		}
	}

	const open = Boolean(anchorEl);

	const handleTimeClick = (time: any) => {
		let fDate = UtilityService.convertToDateFormat(value);
		let fTime = UtilityService.convertToTimeFormat(time);
		// for maintance will be removed in feature		
		// let fDate = moment(value, ["MM-DD-YYYY HH:mm"]
		// ).format("MM-DD-YYYY");
		// let fTime = moment(new Date(time), ["HH:mm"]
		// ).format("HH:mm");

		// let x = moment(`${fDate} ${fTime}`
		// ).format(`MM-DD-YYYY HH:mm`);
		let x = UtilityService.convertToDateTimeFormat(`${fDate} ${fTime}`)
		setValue(new Date(x))
	}

	const trimTimeZone = (timeZoneName: any, maxLength: number) => {
		return !!timeZoneName ? timeZoneName.slice(0, maxLength) + (timeZoneName.length > maxLength ? "..." : "") : "";
	}

	const handleSave = () => {
		props.handleChange(UtilityService.roundTimeToMinutes(new Date(value).getTime(), minuteStep),props.ID);
		setValue(UtilityService.getPreferredTimeZoneTimeNow())
		handleClose();
		if (props.IsMobileDevice && props.CloseBottomDrawer) {
			props.CloseBottomDrawer();
		}
	}

	const handleResetIcon = (event: any) => {
		event.stopPropagation()
		setAnchorEl(null);
		props.handleChange(-1,props.ID)
	};

	return (
		<>
			{props.event == undefined ? <TextField
				size={props.TextFiledMediumSize ? "medium" : "small"}
				fullWidth
				id="input-with-icon-textfield"
				label={props.TextLabel}
				className="br-1"
				tabIndex={17}
				onClick={handleClick}
				value={props.DateTime === -1 ? (props.FormatTextLabel || "MM DD YYYY HH:mm") :
					moment(props.DateTime).format(props.FormatText || `MMMM Do YYYY HH:mm`)}
				InputProps={{
					classes: { input: 'h6-regular color-text-field-font', notchedOutline: 'br-text-field w-fill' },
					startAdornment: (
						<InputAdornment position="start">
							<button tabIndex={17} data-up-arrow-index={300} onClick={handleClick}>
								<DateTimePickerIcon className={`c-pointer`}
								/>
							</button>
						</InputAdornment>
					),
					endAdornment: (props.ShowRestIcon && props.DateTime !== -1 &&
						<InputAdornment position="end">
							<button tabIndex={17} data-up-arrow-index={300} onClick={handleResetIcon}>
								<ResetIcon className={`c-pointer`}
								/>
							</button>
						</InputAdornment>
					),

				}}
				inputProps={{
					autocomplete: "off"
				}}
				variant="outlined"
			/> : <> </>}

			<Popover
				anchorOrigin={{
					vertical: 'top',
					horizontal: 'right',
				}}
				transformOrigin={{
					vertical: 'bottom',
					horizontal: 'right',
				}}
				open={props.isMessage ? props.isMessage : props.event !== undefined ? openCalender : open}
				anchorEl={props.anchorEl ? props.anchorEl : props.event !== undefined ? props.event.current : anchorEl}
				onClose={handleClose}
				hideBackdrop={!props.HideTime}
				classes={{ paper: `${props.IsMobileDevice ? "min-w-30" : ""}` }}
			>
				<Card className={`d-flex ${props.IsMobileDevice ? props.DeviceWidth < 373 ? "py-1 flex-direction align-center" : "" : "py-1"}`}>
					<>
						<div className="d-flex flex-direction">
							<div>
								<Calendar
									onClickDay={onChange}
									value={value}
									minDate={!props.MaxDate && UtilityService.getPreferredTimeZoneTimeNow()}
									maxDate={props.MaxDate ? UtilityService.getPreferredTimeZoneTimeNow() : props.maxDateTime ? UtilityService.convertToPreferredTimeZone(props.maxDateTime) : null}
								// maxDate={props.maxDateTime ? UtilityService.convertToPreferredTimeZone(props.maxDateTime) : props.MaxDate && UtilityService.getPreferredTimeZoneTimeNow()}
								/>
							</div>
							<div className="pt-1 pl-1 m-auto d-flex">
								<div className="m-auto">
									Account time zone: {trimTimeZone(UtilityService.getPreferedTimeZone().Name, 15)} ({UtilityService.getPreferedTimeZone().OffsetLabel})
								</div>
								<Tooltip title={"By default Scheduled messages are sent based on your account time zone."} placement="top-end"  >
									<InformationDarkScheduleIcon className="pl-1 m-auto" />
								</Tooltip>
							</div>
						</div>
						{!props.HideTime && <>
							<div className={"datetime-divider"} />
							<div className={` ${props.IsMobileDevice ? "d-flex flex-direction justify-item-center" : "px-1"}`}>
								<ArrowTimePickerTimeComponent handleChange={handleTimeClick} MinuteStep={minuteStep} HourStep={1} Value={props.DateTime} maxTime={props.maxDateTime} IsMobileDevice={props.IsMobileDevice} SelectedDate={selectedDate} />
								<ButtonComponent ButtonLabel={"save"} ClassName={` p-0 h5-regular br-0 ${props.IsMobileDevice ? "w-p-80 mx-auto" : "w-p-100"}`} Variant={"primary-btn"} OnClick={handleSave}></ButtonComponent>
								<ButtonComponent ButtonLabel={" cancel"} ClassName={` mt-1 p-0 h5-regular br-0 ${props.IsMobileDevice ? "w-p-80 mx-auto" : "w-p-100"}`} Variant={"secondary-btn-small"} OnClick={() => { handlePopoverClose() }}></ButtonComponent>
							</div>
						</>}
					</>
				</Card>
			</Popover>
		</>
	);
}
